module.exports = __webpack_public_path__ + "static/media/taskeen.90762708.png";